const Studies = theme => {
  return {
    background: {
      backgroundImage:
        'linear-gradient(to right top, #4f848e, #3582ab, #5c76be, #a05cb3, #d33381)',
    },
    foreground: {
      color: 'rgba(137,220,243,.7)'
    }
  }
}

export default Studies



// WEBPACK FOOTER //
// ./src/styles/mixins/gradients/studies.js